import { render, staticRenderFns } from "./lrEditTable.vue?vue&type=template&id=28c9f9d1&"
import script from "./lrEditTable.vue?vue&type=script&lang=js&"
export * from "./lrEditTable.vue?vue&type=script&lang=js&"
import style0 from "./lrEditTable.vue?vue&type=style&index=0&id=28c9f9d1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports